<template>
  <span class="rb-icon" :class="type">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'rb-icon',
  props: {
    type: {
      type: String,
      default: 'material-icons'
    }
  },
};
</script>

<style lang="scss">

</style>
